import request from 'superagent'

export const stage = 'development'
// export const stage = 'staging'
// export const stage = 'development'
const API_VERSION = '1.2'

const TIMEOUT_RESPONSE = 10000
const TIMEOUT_DEADLINE = 30000

const API_URLS = {
  production: `https://api.sarafan-app.ru`,
  staging: `https://api-staging.sarafan-app.ru`,
  development: ``,
}
export const API_URL = `${API_URLS[stage]}/api/v${API_VERSION}`

const API_ENDPOINTS = {
  send_verification_sms:  `${API_URL}/send-verification-sms`,
  login_phone:            `${API_URL}/login-phone`,
  skills:                 `${API_URL}/skills`,
  confirm_pro_link:       `${API_URL}/prolinks/confirm/{hash}`,
  get_pro_link:           `${API_URL}/prolinks/get_by_hash/{hash}`,
}

var accessToken = null;

export default class Api {
  static accessToken = null;

  static handleErrors(error) {
    // ResponseHandler.handleResponse(response)
    console.log("global error handler:");
    console.log(error);
  }

  static handleResponse(response: request.Response) {
    console.log("global response handler: " + response.status)
    if (response.body !== null &&
        response.body.access_token !== undefined &&
        response.body.access_token !== '' &&
        response.body.access_token !== null)
    {
      accessToken = response.body.access_token;
    }
  }

  static postRequest(endpoint: string, body = {}, headers = {}) {
    const head = {
      ...headers,
      'Sarafan-Access-Token': accessToken,
    }
    return request
      .post(endpoint)
      .timeout({ response: TIMEOUT_RESPONSE, deadline: TIMEOUT_DEADLINE })
      .set(head)
      .send(body)
      .accept('application/json')
      .on('response', this.handleResponse)
      .on('error', this.handleErrors)
  }

  static getRequest(endpoint: string, body = {}, headers = {}) {
    const head = {
      ...headers,
      'Sarafan-Access-Token': accessToken,
    }
    return request
      .get(endpoint)
      .timeout({ response: TIMEOUT_RESPONSE, deadline: TIMEOUT_DEADLINE })
      .query(body)
      .set(head)
      .accept('application/json')
      .on('response', this.handleResponse)
      .on('error', this.handleErrors)
  }

  static getProLink(hash: string) {
    const endpoint = API_ENDPOINTS.get_pro_link.replace('{hash}', hash)

    return this.getRequest(endpoint, {})
  }

  static sendVerificationSms({ phone }: { phone: string | null }) {
    const endpoint = API_ENDPOINTS.send_verification_sms
    const body = {
      phone_number: phone,
    }

    return this.postRequest(endpoint, body)
  }

  static loginPhone({ phone, code, verificationToken }: { phone: string, code: string, verificationToken: string }) {
    const endpoint = API_ENDPOINTS.login_phone
    const body = {
      phone_number: phone,
      code: code,
      verification_token: verificationToken
    }

    return this.postRequest(endpoint, body)
  }

  static confirmProLink(hash: string) {
    const endpoint = API_ENDPOINTS.confirm_pro_link.replace('{hash}', hash)

    return this.postRequest(endpoint, {})
  }
}



// WEBPACK FOOTER //
// ./src/Api/index.js